import IndicatorIcon_module_default from "./IndicatorIcon.module.js";
import classNames from "classnames";
import React, { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Icon/IndicatorIcon/IndicatorIcon.tsx
var IndicatorIcon = forwardRef(function IconButton({ children, className, size = "100%", colour, indicator }, ref) {
	return /* @__PURE__ */ jsx("div", {
		ref,
		className: classNames(IndicatorIcon_module_default["indicator-icon"], className),
		"data-indicator": indicator,
		style: {
			"--cpd-icon-button-size": size,
			"--cpd-color-icon-tertiary": colour
		},
		children: React.Children.only(children)
	});
});
//#endregion
export { IndicatorIcon };

//# sourceMappingURL=IndicatorIcon.js.map